import { radius, theme } from '../theme'
import { TraceRegion } from '../lib/trace'
import { Page } from '../components/ui'
import { Mascot } from '../components/Mascot'
import { sfx } from '../lib/sound'
import { BackRow } from './MysteryWord'

/**
 * The games room. Free play, outside the sessions, as often as a child likes.
 *
 * The top two in research/word-games.md, and hangman, which Sam added on 18
 * Oct 2026. All are built from the child's own words and all are for fun: they save nothing and
 * cannot grow the garden or the tree (D-063). Saying so on the screen is for
 * the parent as much as the child.
 */
export function Games({
  onCrossword, onMystery, onHangman, onHome,
}: { onCrossword: () => void; onMystery: () => void; onHangman: () => void; onHome: () => void }) {
  const card = (emoji: string, title: string, line: string, onClick: () => void) => (
    <button
      type="button"
      onClick={() => { sfx.tap(); onClick() }}
      style={{
        display: 'flex', alignItems: 'center', gap: 16, width: '100%', textAlign: 'left',
        background: theme.card, border: `1px solid ${theme.borderWarm}`, borderRadius: radius.xl,
        padding: 18, cursor: 'pointer', fontFamily: 'inherit',
        boxShadow: `0 3px 0 ${theme.borderWarm}`,
      }}
    >
      <span style={{
        fontSize: 34, width: 64, height: 64, flexShrink: 0, display: 'grid', placeItems: 'center',
        background: theme.greenPale, borderRadius: radius.lg,
      }}>{emoji}</span>
      <span>
        <span style={{ display: 'block', fontSize: 20, fontWeight: 800, color: theme.text }}>{title}</span>
        <span style={{ display: 'block', fontSize: 15, color: theme.muted, lineHeight: 1.45, marginTop: 2 }}>{line}</span>
      </span>
    </button>
  )

  return (
    <Page width={560}>
      <BackRow onBack={onHome} label="← Home" />
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '4px 0 16px' }}>
        <Mascot size={70} mood="cheer" />
        <div>
          <h1 style={{ margin: 0, fontSize: 28, color: theme.text }}>Word games</h1>
          <p style={{ margin: '4px 0 0', fontSize: 16, color: theme.muted }}>
            Made from your own words. Play as many as you like.
          </p>
        </div>
      </div>
      <TraceRegion id="T7" note="the puzzles are built from this child's words (T7 learner_word, with T3 word and T4 word_sense). Nothing played here is saved">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {card('🧩', 'Mini crossword', 'Read the meaning, find the word. A new one every time.', onCrossword)}
        {card('🔍', 'Mystery word', 'Guess the hidden word. Colors tell you which letters are right.', onMystery)}
        {card('🌼', 'Hangman', 'Guess the letters before the flower loses its petals.', onHangman)}
      </div>
      </TraceRegion>
      <p style={{ margin: '20px 4px 0', fontSize: 13, color: theme.faint, lineHeight: 1.5 }}>
        Games are just for fun. They don’t change your garden or your tree. Those grow in practice.
      </p>
    </Page>
  )
}
